import React from 'react';
import { useSelector } from 'react-redux';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';

import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';

import PayWallEditableAddress from './PayWallEditableAddress';

export default function PayWallBillingAddressDialog() {
  const billingAddressDialogOpen = useSelector((state: PayWallFullState) => state.payWall.billingAddressDialogOpen);

  return (
    <Dialog open={billingAddressDialogOpen} maxWidth="sm">
      <DialogTitle>Address required</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography type="body1">
            In order to correctly calculate taxes, we need your organization address.
          </Typography>
        </Box>
        <PayWallEditableAddress />
      </DialogContent>
    </Dialog>
  );
}
